export default "__VITE_ASSET__D1CSH2Kr__"